import { Button, Typography } from "@mui/material";
import BasketIcon from "../Icons/Basket";
import { colorGrayDark, colorGrayLight } from "../../styles/theme";
import { useDocuments } from "../../context/DocumentContext";
import { usePanelContext } from "../../context/PanelContext";
import ToggleCardView, { CardViewOption } from "../CardItem/ToggleCardView";

const OpenBasketButton: React.FunctionComponent = ({}) => {
	const { documentsInBasket } = useDocuments();
	const { toggleCardView } = usePanelContext();
	return (
		<Button
			onClick={() => toggleCardView(null, CardViewOption.BASKET)}
			sx={{
				paddingLeft: "15px",
				paddingRight: "15px",
				width: "auto",
				height: "60px",
				textTransform: "none",
				fontSize: "18px",
				position: "relative",
				borderLeft: `1px solid ${colorGrayLight}`,
				borderRadius: "0 !important",
			}}
		>
			<BasketIcon />
			<Typography
				variant="caption"
				color={colorGrayDark}
				sx={{ position: "absolute", top: "15px", right: "13px" }}
			>
				{documentsInBasket.length}
			</Typography>
		</Button>
	);
};

export default OpenBasketButton;
